import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../store";

// Define a type for the slice state
interface AddRessourceState {
  name: string;
  fileUrl: string;
  fileType: string;
  loading: boolean;
}

// Define the initial state using that type
const initialState: AddRessourceState = {
  fileType: "",
  name: "",
  fileUrl: "",
  loading: false,
};

export const addRessourceSlice = createSlice({
  name: "addRessource",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setName: (state, action: PayloadAction<string>) => {
      state.name = action.payload;
    },
    setFile: (state, action: PayloadAction<any>) => {
      state.fileUrl = action.payload;
    },
    setFileType: (state, action: PayloadAction<any>) => {
      state.fileType = action.payload;
    },
    setLoadingRessource: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const { setName, setFile, setLoadingRessource, setFileType } =
  addRessourceSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const getAddRessourceData = (state: RootState) => state.addRessource;
export default addRessourceSlice.reducer;
